export default "__VITE_ASSET__Bumdp_Ld__"